import { useSyncExternalStore } from "react";

/**
 * Tailwind's `md`, and the width the brandbook's room shell stops drawing its
 * people column beside the stage at. A room reads it from here, so whether the
 * column stands beside the stage or covers the room is decided in one place
 * (`RoomFrame`, `useRoomPanels`).
 */
const MOBILE_BREAKPOINT = 768;

const query = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const subscribe = (onChange: () => void) => {
  const mql = window.matchMedia(query);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
};

const isNarrow = () => window.innerWidth < MOBILE_BREAKPOINT;

export function useIsMobile() {
  // Server snapshot: assume desktop; corrected on hydration.
  return useSyncExternalStore(subscribe, isNarrow, () => false);
}
